// modules
import { addModal } from 'weblite-web-modal-viewer'
import { WappBarMenu } from './wapp-bar-menu'

const COMPONENT_ID = 'wappBarMenu'

export const showWappBarMenu = (props: Parameters<typeof WappBarMenu>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: WappBarMenu,
  },
}
